import type { ActivityType } from '@/data/idp/interfaces';
import type { Course, CourseTypes } from '@/models/catalog/course';
import type {
  EmbeddedCourse,
  ExternalResource,
  ResourceTypes,
} from '@/models/resources';

export enum PlanStatus {
  Closed = 'closed',
  Draft = 'draft',
  InProgress = 'in_progress',
}

export enum PlanStatusLabels {
  Closed = 'Plano finalizado',
  Draft = 'Plano em rascunho',
  InProgress = 'Plano em andamento',
}

export enum ActivityStatus {
  Pending = 'pending',
  InProgress = 'in_progress',
  Completed = 'completed',
}

export interface ExternalLink extends Omit<ExternalResource, 'category'> {
  category: ResourceTypes;
}

export interface AttachedResource {
  course?: EmbeddedCourse;
  embedded_course?: EmbeddedCourse;
  marketplace_course?: Course;
  external_link?: ExternalLink;
}

export interface Activity {
  description: string;
  id: string;
  plan_id: string;
  title: string;
  status: ActivityStatus;
  recommended_activity: {
    id: string;
    name: string;
    activity_type: ActivityType;
    course_type: CourseTypes;
  };
  attached_resource?: AttachedResource | null;
  type: ActivityType;
}

export interface Plan {
  id: string;
  activities: Activity[];
  status: PlanStatus;
  title: string;
  duration_in_months: number | null;
  ended_at: string | null;
  estimated_ends_at: string | null;
  started_at: string | null;
  description: string;
  profile_based_recommendation: {
    id: string;
    completed_at: string | null;
  };
  feedback_ids: number[];
}

export interface PlansByStatus {
  [PlanStatus.Draft]: Plan[];
  [PlanStatus.InProgress]: Plan | undefined;
  [PlanStatus.Closed]: Plan[];
}

export interface CreatePlanPayload {
  title?: string | null;
  description?: string | null;
  duration_in_months?: number | null;
}

export interface UpdatePlanPayload extends CreatePlanPayload {
  id: string;
  feedback_ids?: number[];
}
